<template>
    <div class='main'>
        <div class='plugins-tips'>
            <el-row>
                <el-col :span='22'>
                    <el-form ref='queryForm' :inline='true' :model='queryParams' size='small'>
                        <el-form-item prop='dictType' style='margin-bottom: 0'>
                            <el-input
                                size='mini'
                                v-model='queryParams.traceId'
                                clearable
                                placeholder='请输入链路ID'
                                style='width: 240px'
                                @keyup.enter.native='handleQuery'
                            />
                        </el-form-item>
                        <el-form-item style='margin-bottom: 0'>
                            <el-select clearable size='mini' v-model='queryParams.operateType' placeholder='业务类型'>
                                <el-option
                                    v-for='item in businessTypeOptions'
                                    :key='item.label'
                                    :label='item.label'
                                    :value='item.value'>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style='margin-bottom: 0'>
                            <el-date-picker
                                size='mini'
                                v-model='timePicker.pickerTimeValue'
                                type='daterange'
                                align='right'
                                unlink-panels
                                range-separator='至'
                                start-placeholder='开始日期'
                                end-placeholder='结束日期'
                                value-format='yyyy-MM-dd'
                                @blur='handleTimePickerBlur'
                                :picker-options='timePicker.pickerOptions'>
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item style='margin-bottom: 0'>
                            <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                            </el-button>
                            <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>
        
        <div>
            <el-card style='margin-bottom: 1rem;' v-for='(item, index) in slowlyExecuteLogList' :key='index'>
                <el-descriptions :title='item.title' :column='1'>
                    <el-descriptions-item label='日期'>{{ item.createdAt }}</el-descriptions-item>
                    <el-descriptions-item label='请求URI'>{{ item.requestUrl }}</el-descriptions-item>
                    <el-descriptions-item label='耗时'>
                        <span style='color: #F56C6C'>{{ item.consumeTime }} ms</span>
                    </el-descriptions-item>
                    <el-descriptions-item :span='2' label='操作类型'>
                        <el-tag size='mini'>{{ item.operateType }}</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label='链路ID'>
                        <el-button @click='handleLogTraceChain(item)' type='text'>{{ item.traceId }}</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label='执行参数'>
                        <vue-json-pretty :data='item.executeParam' />
                    </el-descriptions-item>
                </el-descriptions>
            </el-card>
        </div>
        
        <div class='pagination'>
            <el-pagination
                :current-page='queryParams.pageNum'
                :page-sizes='[15, 30, 45, 60, 75]'
                :page-size='queryParams.pageSize'
                :total='queryParams.total'
                background
                layout='sizes, prev, pager, next'
                @size-change='handleSizeChange'
                @current-change='handlePagination'>
            </el-pagination>
        </div>
        
        <el-dialog title='日志链路追踪' :visible.sync='logTraceOpen' append-to-body
                   width='55%'>
            <el-card style='white-space: pre-line;max-height: 60vh;overflow-y: scroll;' class='box-card'>
                <div slot='header' class='clearfix'>
                    <el-row :gutter='20'>
                        <el-col :span='12'>
                            <span>链路ID为 <span style='color: #409EFF'>{{ currentLogInfo.traceId }}</span>的执行日志链路</span>
                        </el-col>
                        <el-col :span='12'>
                            <el-switch
                                @change='handleSwitchChange'
                                v-model='isContainOtherService'
                                inactive-text='包含其他服务'>
                            </el-switch>
                        </el-col>
                    </el-row>
                </div>
                <el-timeline>
                    <el-timeline-item :type='item.exceptionStatus ? "danger" : "success"'
                                      v-for='(item, index) in logExceptionTraceChain'
                                      :timestamp='`${item.title}   ${item.createTime}`' placement='top'>
                        <el-descriptions :column='1'>
                            <el-descriptions-item label='日期'>{{ item.createTime }}</el-descriptions-item>
                            <el-descriptions-item label='是否发生异常'>
                                <el-tag size='mini' :type='item.exceptionStatus ? "danger" : "success"'>
                                    {{ item.exceptionStatus }}
                                </el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item label='操作者'>{{ item.operator }}</el-descriptions-item>
                            <el-descriptions-item label='请求URI'>{{ item.requestUri }}</el-descriptions-item>
                            <el-descriptions-item label='请求方法'>
                                <el-tag size='mini'>{{ item.requestMethod }}</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item label='请求数据'>
                                <span>{{ item.requestData }}</span>
                            </el-descriptions-item>
                            
                            <el-descriptions-item v-if='!item.exceptionStatus' label='响应数据'>
                                <span>{{ item.responseData }}</span>
                            </el-descriptions-item>
                            
                            <el-descriptions-item v-if='item.exceptionStatus' :span='2' label='异常堆栈'>
                                <el-card shadow='never'
                                         style='white-space: pre-line;max-height: 30vh;overflow-y: scroll;'
                                         class='box-card'>
                                    <div style='color: #f56c6c;'>{{ item.exceptionStackTrace }}</div>
                                </el-card>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-timeline-item>
                </el-timeline>
            </el-card>
            <div slot='footer' class='dialog-footer'>
                <el-button @click='logTraceOpen = false'>取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import { pageUtil } from '@/utils/pageUtil';
import { trackReportSettingApi } from '@api/Track/trackReportSetting';
import { message } from '@/utils/message';
import TrackEventChart from '@view/track/analyse/component/TrackEventChart.vue';
import { applicationCredentialApi } from '@api/Storage/applicaitonCredentialConfig';
import { logApi } from '@api/Log/log';
import { slowlyExecuteApi } from '@api/Storage/slowlyExecute';
import VueJsonPretty from 'vue-json-pretty';

export default {
    name: 'SlowExecuteLog',
    components: { VueJsonPretty, TrackEventChart },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            updateStatus: false,
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                pageSize: 15,
                pageNum: 1,
                total: 0,
                limit: 15,
                skip: 0,
                resultTotal: undefined,
                startTime: undefined,
                endTime: undefined,
                operateType: undefined,
                traceId: undefined,
                className: undefined,
                projectName: undefined
            },
            businessTypeOptions: [
                {
                    label: '新增操作',
                    value: 'CREATE'
                },
                {
                    label: '修改操作',
                    value: 'UPDATE'
                },
                {
                    label: '删除操作',
                    value: 'DELETE'
                },
                {
                    label: '查询操作',
                    value: 'QUERY'
                },
                {
                    label: '其他',
                    value: 'NONE'
                }
            ],
            timePicker: {
                pickerTimeValue: [],
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近一个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近三个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近五个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 150);
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ]
                }
            },
            applicationConfigInfo: {},
            storageLogList: [],
            logExceptionTraceChain: [],
            currentLogInfo: {},
            logTraceOpen: false,
            slowlyExecuteLogList: [],
            isContainOtherService: false
        };
    },
    props: {
        appId: {
            type: String
        },
        className: {
            type: String
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryParams.className = this.className;
        this.setInitValue();
    },
    beforeDestroy() {
    
    },
    methods: {
        setInitValue() {
            this.getList();
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        async handleSortChange({ column, prop, order }) {
            await pageUtil.handleSortChange(prop, order, this.queryParams.sortSqlList);
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
            this.getList();
        },
        async initData() {
            let applicationConfig = await applicationCredentialApi.queryByAppId({ appId: this.appId });
            this.applicationConfigInfo = applicationConfig.data;
            this.queryParams.projectName = `CloudStorage_${this.applicationConfigInfo.appName}`;
        },
        async getList() {
            if (!this.queryParams.projectName) {
                await this.initData();
            }
            this.queryParams.skip = this.queryParams.pageNum - 1;
            this.queryParams.limit = this.queryParams.pageSize;
            this.loading = true;
            slowlyExecuteApi.queryList(this.queryParams, this.appId).then(result => {
                if (result.data.results) {
                    this.queryParams.total = result.data.count;
                    this.slowlyExecuteLogList = result.data.results;
                }
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
            this.resetReportSetting();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                pageSize: 15,
                pageNum: 1,
                total: 0,
                limit: 15,
                skip: 0,
                resultTotal: undefined,
                startTime: undefined,
                endTime: undefined,
                operateType: undefined,
                traceId: undefined,
                className: this.queryParams.className,
                projectName: this.queryParams.projectName
            };
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.updateStatus = true;
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '新增事件分析';
            this.updateStatus = false;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.currentReportSetting = row;
            this.open = true;
            this.updateStatus = true;
            this.title = '修改事件报表设置';
            this.setReportSettingParam(row);
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            let obj = this;
            this.$modal.confirm('是否确认删除"' + row.name + '"的数据项？').then(function() {
                return trackReportSettingApi.deleteData(row);
            }).then((result) => {
                if (result.code === 200) {
                    message.success(result.message);
                    obj.getList();
                }
            }).catch(() => {
            });
        },
        /** 提交按钮 */
        submitForm: function() {
            this.packageReportSetting(this.updateOrAddReportSetting);
        },
        handleTimePickerBlur() {
            if (this.timePicker.pickerTimeValue.length === 0) {
                return;
            }
            this.queryParams.startTime = this.timePicker.pickerTimeValue[0] + ' 00:00:00';
            this.queryParams.endTime = this.timePicker.pickerTimeValue[1] + ' 23:59:59';
        },
        handleLogTraceChain(row) {
            this.currentLogInfo = row;
            this.logExceptionTraceChain = [];
            this.logTraceOpen = true;
            this.isContainOtherService = false;
            logApi.queryLog({
                pageNum: 1, pageSize: 1000000, traceId: row.traceId,
                sortSqlList: ['createTime ASC'], projectName: this.queryParams.projectName
            }).then(result => {
                if (result.code === 200) {
                    this.logExceptionTraceChain = result.data.result;
                }
            });
        },
        handleSwitchChange(value) {
            this.logExceptionTraceChain = [];
            if (value) {
                logApi.queryLog({
                    pageNum: 1, pageSize: 1000000, traceId: this.currentLogInfo.traceId,
                    sortSqlList: ['createTime ASC']
                }).then(result => {
                    if (result.code === 200) {
                        this.logExceptionTraceChain = result.data.result;
                    }
                });
            } else {
                logApi.queryLog({
                    pageNum: 1, pageSize: 1000000, traceId: this.currentLogInfo.traceId,
                    sortSqlList: ['createTime ASC'],
                    projectName: this.queryParams.projectName
                }).then(result => {
                    if (result.code === 200) {
                        this.logExceptionTraceChain = result.data.result;
                    }
                });
            }
        }
        
    }
};
</script>
<style lang='css'>

</style>
